export default __webpack_public_path__ + "static/media/icon-produccion-integral.78afdf64.svg";